import { action } from 'easy-peasy';
import { IActionShowNotify } from '~/store/snackbar/types';

const showNotify: IActionShowNotify = action((state, payload) => {
  state.message = payload;
  state.isError = false;
});

export default showNotify;
